import script from "./PermissionsBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionsBlock.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionsBlock.vue?vue&type=style&index=0&id=8919b6b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8919b6b8"]])

export default __exports__